import { Dispatch } from "redux";
import {LoginService} from "../services/LoginService";
import {passwordapi} from"../ApiNames";


export const fetchDataSuccess=(countrydata:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: countrydata,
});
export const fetchRegisterDataSuccess=(regdata:any) =>({
    type: 'FETCH_REG_DATA_SUCCESS',
    payload: regdata,
});

export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid };
            const apiname = passwordapi.getcountrys;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const register = (usertype:any,country:any,firstname:any,lastname:any,email:any,password:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {usertype:usertype,country:country,firstname:firstname,lastname:lastname,email:email,password: password};
            const apiname = passwordapi.registerdata;
            // const response = await LoginService.getData(apiname,payload)
            const response = await LoginService.getData(apiname, payload);

            dispatch(fetchRegisterDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};